export default function handleFollow(params) {
  const tenantId = params.get("tenantId");
  const followerEmail = decodeURIComponent(params.get("emailId") || "");

  return {
    action: "Follow",
    tenantId,
    followerEmail,
  };
}
